// removed by extract-text-webpack-plugin
module.exports = {"grid-preview":"bmbo_grid-preview_1i8PK","col":"bmbo_col_2VORM"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Components/GridPage.scss
// module id = 97
// module chunks = 0